/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    accept: {
        text: "Accepte"
    },
    fileExtensionError: {
        text: "Annulé : L'extension du fichier n'est pas autorisée"
    },
    maxSizeError: {
        text: "Annulé : Taille des fichiers dépassant les "
    },
    multipleError: {
        innerHTML: "Un seul fichier attendu"
    },
    sizeLimit: {
        text: "Taille maximale"
    },
    sizeUnit: {
        text: "Mo"
    }
};